export default {
  install(Vue) {
      Vue.directive('clickOutSide', {
          bind(el, binding) {
              el.handler = function(e) {
                  if (el.contains(e.target)) {
                      return;
                  }
                  if (typeof binding.value === 'function') binding.value();
              }
              // el.stopProp = function(event) {
              //     event.stopPropagation();
              // }
              // el.addEventListener('click', el.stopProp)
              document.body.addEventListener('click', el.handler)
          },
          unbind(el) {
              // el.removeEventListener('click', el.stopProp)
              document.body.removeEventListener('click', el.handler)
          }
      })

  }
}


// WEBPACK FOOTER //
// ./src/directive.js